import type { ReactNode } from 'react';
import { Description, Heading } from '@heroui/react';
import { AppBrandMark } from '../../../components/ui/app-brand-mark';
import { ThemeToggle } from '../../../components/ui/theme-toggle';

interface AuthSplitLayoutProps {
  children: ReactNode;
}

export function AuthSplitLayout({ children }: AuthSplitLayoutProps) {
  return (
    <div className="grid min-h-screen bg-background lg:grid-cols-2">
      <aside className="relative hidden flex-col justify-between bg-accent p-10 pt-[max(2.5rem,env(safe-area-inset-top))] text-accent-foreground lg:flex">
        <div className="flex items-center gap-3">
          <AppBrandMark iconSize={24} className="size-11 rounded-xl" />
          <span className="text-lg font-semibold">Link Park</span>
        </div>
        <div className="space-y-3">
          <Heading level={1} className="text-3xl font-bold leading-tight">
            Gerencie vagas do seu condomínio
          </Heading>
          <Description className="text-accent-foreground/80 text-base">
            Reserve, empreste e acompanhe o uso de vagas em um só lugar.
          </Description>
        </div>
        <Description className="text-accent-foreground/60 text-sm">
          © {new Date().getFullYear()} Link Park
        </Description>
      </aside>

      <main className="relative flex min-h-screen flex-col items-center justify-center overflow-y-auto px-6 py-12 pt-[max(3rem,env(safe-area-inset-top))] lg:min-h-full">
        <ThemeToggle className="absolute right-4 top-[max(1rem,env(safe-area-inset-top))]" />
        <div className="mb-8 flex items-center gap-2 lg:hidden">
          <AppBrandMark iconSize={22} className="size-10 rounded-lg" />
          <span className="text-lg font-semibold">Link Park</span>
        </div>
        {children}
      </main>
    </div>
  );
}
